<template>
  <div class="animated fadeIn">
    <div class="pre-scrollable  " style="max-height: 82vh; overflow-x: hidden;">
      <b-navbar :no-body="true" class="p-0 " fixed :sticky="true" toggleable="lg" type="dark" variant="dark">
        <b-navbar-brand>
            <i class='px-3 fa fa-address-book-o'></i><strong>  PRODUTOS</strong> <small>Informe os Filtros</small>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <!--
              <b-button type="button" variant="secondary" @click="aguarde = true">Launch demo modal</b-button>
              -->
                
              <b-button v-if="filtroCabecalho === false" class="px-2  "   type="button" variant="dark" @click.stop="filtroCabecalho = !filtroCabecalho" > 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-newspaper-o"></i></span>
              </b-button>  
              <b-button v-else class="px-2  "   type="button" variant="dark" @click.stop="filtroCabecalho = !filtroCabecalho" > 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-newspaper-o text-success"></i></span>
              </b-button>  
              
              <b-button class="px-2 f " type="reset"  variant="dark"  @click.stop.prevent="limparFiltro()">
                <span style="font-size: 1.2rem" > <i  class="fa fa-ban"></i></span>
              </b-button>                            
              
              <b-button class="px-2  "  variant="dark" type="button"  > 
                 <span style="font-size: 1.2rem" > <i  class="fa fa-print"></i></span>
              </b-button>   
              <c-switch type="text"   class="px-1 p-0 md-0" variant="primary-outline-alt" on="ATV" off="FEC" :checked="true" v-model="filtroAvancado"/>
              <b-pagination class=" mb-0 bg-gray-100" :limit="2" style="font-size: 1.2rem" :total-rows="this.lista.length" :per-page="perPage" v-model="currentPage" />
              <b-form-select class=" px-3 bg-gray-100"  style="font-size: 1.2rem" :options="[{text:20,value:20},{text:30,value:30},{text:50,value:50}, {text:100,value:100}]" v-model="perPage">
                </b-form-select>
              <!--<strong class="px-1 text-light">  De: </strong>-->
              <b-form-input type="text" id="edDescricao" ref="edDescricao"
                            placeholder="Informe a Descrição min(3 letras)" 
                            v-model="descricao"
                            @keydown.enter="pesquisar()"
                            class=" px-2 bg-gray-100" style="font-size: 1.2rem"> </b-form-input>
              <b-button class="px-2 font-weight-bold" type="button" :disabled="isBusy"  variant="primary" @click.stop.prevent="pesquisar()">
                <span style="font-size: 1.2rem" > <b-spinner v-if="isBusy" small ></b-spinner> <i v-else class="fa fa-search"></i></span>
              </b-button>
              <div class="border-left">                              
                <b-button class="px-4 font-weight-bold" variant="success" ref="btAdicionar" type="button" @click.stop.prevent="novo()" > 
                  <span style="font-size: 1.2rem" >Adicionar Novo  <i  class="fa fa-plus-square-o"></i></span>
                </b-button>
              </div>
              
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>


      <b-card  body-class="alert-dark" v-if="filtroAvancado === true">
          <b-row>
            <b-col sm="2">
              <b-form-group>
                <label for="codigo">Código</label>
                <b-form-input type="text" id="codigo" placeholder="Informe o código" v-model="id" @keydown.enter="pesquisar()"></b-form-input>
              </b-form-group>
            </b-col>
            <!--/.col-->
            <b-col sm="3">
              <b-form-group>
                <label for="cpf">Código Barras EAN13</label>
                <b-form-input type="text" id="cpf" placeholder="Cod. barras" v-model="cpf" @keydown.enter="pesquisar()"></b-form-input>
              </b-form-group>
            </b-col>
            <!--/.col-->
            <b-col sm="6">
              <b-form-group>
                <label for="edGrupoProduto">Grupo de Produtos</label>
                <b-form-input type="text" id="edGrupoProduto" placeholder="Informe a Grupo" v-model="grupoId" @keydown.enter="pesquisar()"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
      </b-card>
      


      <!--/.row-->
      <b-row>
        <b-col sm="12">

            <b-table class="table table-sm"
            
                    head-variant="dark"
                    show-empty
                    empty-text="Informe o filtro para ver os registros "
                    stacked="md"
                    responsive 
                    striped hover 
                    :busy.sync="isBusy" 
                    :items="lista" 
                    :fields="fieldsListagem"
                    :current-page="currentPage"
                    :per-page="perPage"
                    
                    select-mode="single"
                    selectable
                    @row-selected="edit"
                    :tbody-tr-class="rowClassSelecionado"
                    :filter="filtros"
                    :filter-function="rowFilterListagem"     
                    >
                  
              <template #cell(CODIGO)="item">{{item.item.CODIGO}}</template>
              <template #head(CODIGO)>
                <div v-if="filtroCabecalho === true" class="d-flex flex-column">
                  <!-- linha superior: label + info -->
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span>Descrição</span>
                    <small v-if="filtros.CODIGO.length" class="text-white">
                      {{ filtros.CODIGO.length }} selecionada(s)
                      <b-button size="sm" variant="link" class="p-0 ml-1"
                                @click="filtros.CODIGO = []">
                        limpar
                      </b-button>
                    </small>
                  </div>

                  <!-- multiselect -->
                  <Multiselect
                    @click.stop=""
                    v-model="filtros.CODIGO"
                    :options="opcoesUnicasFrom(lista, 'CODIGO')"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Selecione..."
                    :show-labels="false"
                    :max-height="300"
                    open-direction="auto"
                    class="w-100 multiselect-sm "/>
                </div>
              </template>
              <template #cell(DESCRICAO)="item">{{item.item.DESCRICAO}}</template>
              <template #head(DESCRICAO)>
                <div v-if="filtroCabecalho === true" class="d-flex flex-column">
                  <!-- linha superior: label + info -->
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span>Descrição</span>
                    <small v-if="filtros.DESCRICAO.length" class="text-white">
                      {{ filtros.DESCRICAO.length }} selecionada(s)
                      <b-button size="sm" variant="link" class="p-0 ml-1"
                                @click="filtros.DESCRICAO = []">
                        limpar
                      </b-button>
                    </small>
                  </div>

                  <!-- multiselect -->
                  <Multiselect
                    @click.stop=""
                    v-model="filtros.DESCRICAO"
                    :options="opcoesUnicasFrom(lista, 'DESCRICAO')"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Selecione..."
                    :show-labels="false"
                    
                    class="w-100 multiselect-sm "/>
                </div>
              </template>
              <template #cell(REZUMIDO)="item">{{item.item.REZUMIDO}}</template>
              <template #head(REZUMIDO)>
                <div v-if="filtroCabecalho === true" class="d-flex flex-column">
                  <!-- linha superior: label + info -->
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <span>Descrição</span>
                    <small v-if="filtros.REZUMIDO.length" class="text-white">
                      {{ filtros.REZUMIDO.length }} selecionada(s)
                      <b-button size="sm" variant="link" class="p-0 ml-1"
                                @click="filtros.REZUMIDO = []">
                        limpar
                      </b-button>
                    </small>
                  </div>

                  <!-- multiselect -->
                  <Multiselect
                    @click.stop=""
                    v-model="filtros.REZUMIDO"
                    :options="opcoesUnicasFrom(lista, 'REZUMIDO')"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    placeholder="Selecione..."
                    :show-labels="false"
                    :max-height="180"
                    class="w-100 multiselect-sm "/>
                </div>
              </template>
              
              <template #cell(actions)="item">
                <b-button type="button" @click.stop.prevent="details(item.item)" size="sm" variant="danger " >
                  <i class="fa fa-times"></i>
                </b-button>
                <b-button type="button" @click.stop.prevent="copiarProduto(item.item)" size="sm" variant="info " >
                  <i class="fa fa-copy"></i>
                </b-button>
              </template>
            </b-table>
            
            <div class="justify-content-center row my-1">
              <b-pagination size="md" :total-rows="lista.length" :per-page="perPage" v-model="currentPage" />
            </div>
        </b-col>
      </b-row>
    </div>  
  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import cSwitch from '../../../components/Switch'
import filtrosTabelaMixin from '@/utils/filtrosTabelaMixin'

export default {
  components: {
    VueButtonSpinner,
    cSwitch
  },
  mixins: [filtrosTabelaMixin],

  data () {
    return {
      

      isLoading: false,
      status: '',
      isBusy: false,
      filtros: { CODIGO: [], DESCRICAO: [], REZUMIDO: [] },
      filtrosConfig: {
        DESCRICAO: { key: 'DESCRICAO', op: 'in' },
        CODIGO: { key: 'CODIGO', op: 'in' },
        REZUMIDO: { key: 'REZUMIDO', op: 'in' }
      },
      
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalDetails: { index: '', data: '' }
    }
  },
  
  
  computed: {

    // Cada tabela constrói sua própria rowFilter a partir da sua config
    rowFilterListagem() { 
      return this.buildRowFilter(this.filtrosConfig) 
    },
    fieldsListagem: {
      get () {
        return this.$store.getters['produto/FIELDS']
      }, 
      set (value) {
        this.$store.commit("produto/SET_FIELDS", value);
      }
    },
    currentPage: {
      get () {
        return this.$store.getters['produto/PAGINA_ATUAL']
      }, 
      set (value) {
        this.$store.commit("produto/SET_PAGINA_ATUAL", value);
      }
    },
    filtroAvancado: {
      get () {
        return this.$store.getters['produto/FILTRO_AVANCADO']
      }, 
      set (value) {
        this.$store.commit("produto/SET_FILTRO_AVANCADO", value);
      }
    },
    filtroCabecalho: {
      get () {
        return this.$store.getters['produto/FILTRO_CABECALHO']
      }, 
      set (value) {
        this.$store.commit("produto/SET_FILTRO_CABECALHO", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['produto/ID']
      }, 
      set (value) {
        this.$store.commit("produto/SET_ID", value);
      }
    },
    descricao: {
      get () {
        return this.$store.getters['produto/DESCRICAO']
      }, 
      set (value) {
        this.$store.commit("produto/SET_DESCRICAO", value);
      }
    },
    ean: {
      get () {
        return this.$store.getters['produto/EAN']
      }, 
      set (value) {
        this.$store.commit("produto/SET_EAN", value);
      }
    },
    grupoId: {
      get () {
        return this.$store.getters['produto/GRUPO_ID']
      }, 
      set (value) {
        this.$store.commit("produto/SET_GRUPO_ID", value);
      }
    },
    lista: {
      get () {
        return this.$store.getters['produto/LISTA']
      }, 
      set (value) {
        this.$store.commit("produto/SET_LISTA", value);
      }
    },/*
    lista() {
      return this.$store.getters['produto/LISTA']
    }*/
  },
  methods: {


    limparFiltros() {
      this.teste.filtros = { nome: '', cidade: '', status: '' }
    },
    
    async copiarProduto(item) {
      const msg = await this.$bvModal.msgBoxConfirm(`Copiar o Produto: ${item.DESCRICAO} ?`, {
          title: 'Copiar',
          size: 'sm',
          buttonSize: 'xl',
          okVariant: 'success',
          okTitle: 'SIM',
          cancelTitle: 'NÃO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
          noCloseOnEsc: true, 
          noCloseOnBackdrop: true
        })
        
        if (msg == false) return   

        try {
          this.$store.commit('controle/setAguardando', true)
          
          const {data} = await this.$http.post(`/api/protected/produto/copiar`, {id: item.CODIGO})

          if (!data || !data.id) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel copiar!')
            return
          }

          this.$store.commit("produto/SET_LIMPAR", null)
          this.$store.commit("produto/SET_REGISTRO_SELECIONADO_ID", data.id)
          this.$store.commit("produto/SET_ID", data.id)
          this.$store.commit('produto/SET_PAGINA_ATUAL', 1)
          await this.$store.dispatch('produto/GET_LISTA')
          this.$store.commit("produto/SET_LIMPAR_APENAS_FILTRO", null) // limpar o filtro pq ja localizou o registro novo 
          
          this.$router.push(`/cadastros/produto/edit/${data.id}`)

        } catch(err) {
          console.log(err)
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel copiar!')
          return
        } finally {
          this.$store.commit('controle/setAguardando', false)
        }
    },

  /*************************************************************************** */
    rowClassSelecionado(item, type) {
      if (item && type === 'row') {
        return item.CODIGO === this.$store.getters['produto/REGISTRO_SELECIONADO_ID'] ? 'table-success' : ''
      }
    },
    colorirSituacao(item) { 
      return item.OP_SITUACAO_FINANCEIRO === '0' ? 'success' : 'danger'
    },

    traduzirSituacao(item) { 
      return item.OP_SITUACAO_FINANCEIRO === '0' ? 'LIBERADO' : 'BLOQUEADO'
    },
    formatarCampo(campoTexto) {
      if (campoTexto.value.length <= 11) {
          campoTexto.value = this.mascaraCpf(campoTexto.value)
      } else {
          campoTexto.value = this.mascaraCnpj(campoTexto.value)
      }
    },
    retirarFormatacao(campoTexto) {
      // Verifica se campoTexto é nulo ou undefined
      if   ((!campoTexto) 
        || (!(campoTexto instanceof HTMLElement)) 
        || (!campoTexto.hasOwnProperty('value')) 
        || (typeof campoTexto.value !== 'string')) {
        return
      }

      // Remove formatação
      campoTexto.value = campoTexto.value.replace(/(\.|\/|\-)/g, "");
    },
    mascaraCpfCgc(item) {
      if (item.CGC && typeof item.CGC === 'string') {
        return this.formatarCnpjCpf(item.CGC)
      }
      return null
    },
    formatarCnpjCpf(texto) {
      // Remove todos os caracteres que não são números
      const numeros = texto.replace(/\D/g, '');

      // Verifica se é CNPJ (14 dígitos) ou CPF (11 dígitos)
      const cnpjCpfFormatado = numeros.length === 14 ?
        numeros.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5') : // CNPJ
        numeros.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4'); // CPF

      return cnpjCpfFormatado;
    },
    colorirStatus(item) { 
      if (item.STATUS == 'ATIVO') return 'success'
      else 'danger'
    },
    colorirStatusTipoCliente(linha) { 
      let cliente = '0'
      let fornecedor = '0'
      if (linha.OP_CLIENTE && typeof linha.OP_CLIENTE === 'string') {
          cliente = linha.OP_CLIENTE.trim()
      }

      if (linha.OP_FORNECEDOR && typeof linha.OP_FORNECEDOR === 'string') {
          fornecedor = linha.OP_FORNECEDOR.trim()
      }

      if (cliente == '1' && fornecedor == '0') return 'success'
      else if (cliente == '0' && fornecedor == '1') return 'info'
      else if (cliente == '1' && fornecedor == '1') return 'gray-300'
      else 'info'
    },
    traduzirSituacaoTipoCliente(linha) { 
      let cliente = '0'
      let fornecedor = '0'
      if (linha.OP_CLIENTE && typeof linha.OP_CLIENTE === 'string') {
          cliente = linha.OP_CLIENTE.trim()
      }

      if (linha.OP_FORNECEDOR && typeof linha.OP_FORNECEDOR === 'string') {
          fornecedor = linha.OP_FORNECEDOR.trim()
      }

      if (cliente == '1' && fornecedor == '0') return 'CLIENTE'
      else if (cliente == '0' && fornecedor == '1') return 'FORNECEDOR'
      else if (cliente == '1' && fornecedor == '1') return 'produto/FORNECEDOR'
      else return ''
    },
    traduzirIsento(linha) {
      if (linha.ISENTO_ICMS && typeof linha.ISENTO_ICMS === 'string') {
        if (linha.ISENTO_ICMS.trim() == '0'|| linha.ISENTO_ICMS.trim() == '' ) return 'ISENTO'
        else if (linha.ISENTO_ICMS.trim() == '1') return 'SUJEITO'
      }
    },
    limparFiltro() {
      this.$store.commit("produto/SET_LIMPAR", null);
    },
    details (item) {
      alert(JSON.stringify(item.CODIGO))
    },
    edit (item) {
      this.$store.commit("produto/SET_REGISTRO_SELECIONADO_ID", item[0].CODIGO)
      this.$router.push(`/cadastros/produto/edit/${item[0].CODIGO}`)
    },
    novo () {
      this.$router.push(`/cadastros/produto/add`)
    },
    pesquisar () {
      this.$store.commit('controle/setAguardando', true)
      this.$store
      .dispatch('produto/GET_LISTA')
      .then(() => {
        this.$store.commit('controle/setAguardando', false)
      }).catch(err => {
        this.lista = []
        this.$store.commit('controle/setAguardando', false)
        this.toastCount++

        let msg 
        if (err.response && err.response.status) {
          msg = err.response.data
          this.$root.$bvToast.toast(msg, {
            title: 'Falha',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: true
          })
        } else {
          this.$root.$bvToast.toast(`Falha ao pesquisar !! ${err}`, {
            title: 'Falha',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
        }
      })

    },
    handleKeydown(event) {
      if (event.key === "Insert") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.novo()
      } else if (event.key === "Enter") {
        // Simula o clique no botão quando a tecla Insert for pressionada
        this.pesquisar()
      } 
    }
  },
  mounted () {
    // Adiciona o evento de keydown ao document
    setTimeout(() => {
      document.addEventListener("keydown", this.handleKeydown)
    }, 200)
    this.$nextTick(() => {
      this.$refs.edDescricao?.focus()
    })
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown)
  },
}
</script>



// WEBPACK FOOTER //
// src/views/almoxarifado/minhas/MinhasRequisicoesListagem.vue